import { IoLogoWhatsapp } from "react-icons/io";
import { getValueIfObject, parseJson, snakeToNormal } from "../../helpers";
import AnalysisCard from "./analysis-card";
import useBorrowerInfo from "../../store";
import { Fragment, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import WhatsappMsg from "../../../../../Components/WhatsappMsg";
import useAuthStore from "../../../../../store/authStore";
import { IoCloseCircle } from "react-icons/io5";
import { getGupshupConversation } from "../../../../../API";
import useGeneralStore from "../../../../../store/generalStore";

export default function WhatsappResponse({ show = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const [showChats, setShowChats] = useState(show ? true : false);

  const [summaryData, setSummaryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const userData = useAuthStore((state) => state.userData);
  const data = useBorrowerInfo((state) => state.data);
  const analysis = useBorrowerInfo((state) => state.analysis);
  const showAlert = useGeneralStore((state) => state.open_alert);

  const toggle = () => setIsOpen((prev) => !prev);

  function getOrdinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function formatDateWithOrdinal(dateString) {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = date.getDate();
      const month = date.toLocaleDateString("en-GB", { month: "short" });
      return `${getOrdinal(day)} ${month}`;
    } catch (e) {
      return dateString;
    }
  }

  useEffect(() => {
    if (show) {
      setIsOpen(true);
      setShowChats(true);
    }
  }, [show]);

  useEffect(() => {
    const fetchWhatsappSummary = async () => {
      if (isOpen && data?.data?.customer_id) {
        setIsLoading(true);
        setSummaryData([]);
        try {
          const res = await getGupshupConversation({ customer_id: data.data.customer_id });

          if (res && res.summary && Array.isArray(res.summary)) {
            setSummaryData(res.summary);
          } else {
            console.log("No WhatsApp summary found or summary is not an array.");
          }
        } catch (error) {
          console.error("Failed to fetch WhatsApp summary:", error);
          showAlert({ variant: "danger", msg: "Failed to fetch WhatsApp summary" });
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchWhatsappSummary();
  }, [isOpen, data?.data?.customer_id, showAlert]);

  return (
    <>
      {!show && (
        <AnalysisCard
          title="Whatsapp Response"
          tag={analysis?.whatsapp_tag}
          content={getValueIfObject(analysis?.whatsapp_disposition, "scenario_name")}
          icon={IoLogoWhatsapp}
          onClick={toggle}
          data={data}
        />
      )}

      <Offcanvas style={{ width: "28rem", paddingTop: "0.75rem" }} show={isOpen} onHide={toggle} backdropClassName="opacity-0" placement="end">
        <Offcanvas.Header>
          <Offcanvas.Title className="d-flex justify-content-between align-items-center w-100 px-2">
            <div className="fw-600 fs-4">WhatsApp</div>
            <button onClick={toggle} type="button" className="bg-white border-0">
              <IoCloseCircle fill="#999999" size={30} />
            </button>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="row border m-3 rounded-2 p-1" style={{ boxShadow: "inset 0 0 10px #cbcacabd" }}>
            <a
              onClick={() => setShowChats(false)}
              className="col-6 text-center p-2 rounded-2 fs-6"
              style={{
                background: !showChats ? "#009EC1" : "transparent",
                color: !showChats ? "white" : "black",
                cursor: "pointer",
                fontWeight: !showChats ? "bold" : "500",
              }}
            >
              Summary
            </a>
            <a
              onClick={() => setShowChats(true)}
              className="col-6 text-center p-2 rounded-2 fs-6"
              style={{
                background: showChats ? "#009EC1" : "transparent",
                color: showChats ? "white" : "black",
                cursor: "pointer",
                fontWeight: showChats ? "bold" : "500",
              }}
            >
              Chats
            </a>
          </div>
          
          {/* Content Logic */}
          {!showChats ? (
            <div>
              {isLoading && <p className="my-5 text-center text-black">Loading Summary...</p>}
              
              {/* Inner Check: Only shows if not loading and data is empty */}
              {!isLoading && summaryData.length === 0 && (
                <p className="my-5 text-center text-black">Summary Not Found</p>
              )}
              
              {!isLoading && summaryData.length > 0 && (
                <div className="m-3 mt-4 rounded-5 bg-body-tertiary px-2 py-3">
                  {summaryData.map((item, i) => (
                    <div key={i} className="text-black px-3 mb-3">
                      <strong className="fs-5 fw-bold my-2 d-inline-block">
                        {formatDateWithOrdinal(item.date)}
                      </strong>
                      <br />
                      <span className="text-black fs-6">{item.scenario}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <WhatsappMsg
              show={showChats}
              setShow={setShowChats}
              name={data?.data?.customer_name}
              customerId={data?.data?.customer_id}
              isCandidate={false}
              withSendMessage={false}
              isMasked={!userData?.remove_masking}
            />
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}